import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class SplitButtonService {

  constructor() { }

  private activeButtonId: string;
  private subject = new Subject<any>();

  setActiveButton(id: string) {
    this.subject.next(id);
  }

  get subscriber(): Observable<string> {
    return this.subject.asObservable();
  }
}
